import { DEFAULT_LANG } from "../types";

const initialState = {
  defaultLang: "",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case DEFAULT_LANG:
      return {
        ...state,
        defaultLang: action.payload,
      };
    default:
      return state;
  }
}
